export default __webpack_public_path__ + "static/media/logo.bf07a08c.svg";